/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailableProvidersResponse } from '../models/AvailableProvidersResponse';
import type { CreateGameDto } from '../models/CreateGameDto';
import type { CreateGameResponse } from '../models/CreateGameResponse';
import type { GameEntity } from '../models/GameEntity';
import type { GetGamesVaixResponse } from '../models/GetGamesVaixResponse';
import type { GetManyGameEntityResponseDto } from '../models/GetManyGameEntityResponseDto';
import type { LocaleResponse } from '../models/LocaleResponse';
import type { ManualProvidersResponse } from '../models/ManualProvidersResponse';
import type { PROVIDER } from '../models/PROVIDER';
import type { SubproviderResponse } from '../models/SubproviderResponse';
import type { UpdateGameDto } from '../models/UpdateGameDto';
import type { UpdateGameImageResponse } from '../models/UpdateGameImageResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { AggregatorProviderDto } from '../models/AggregatorProviderDto';
import type { ListResponseDto } from '../../response/list-response.dto';
import type { ProviderSettingsDto } from '../models/ProviderSettingsDto';
import { GamePositionDto } from '@/api/generated-client/models/GamePositionDto';
import { UpdateGameImageDto } from '@/api/request/games/update-game-image.dto';
import { UpdateGameIconDto } from '@/api/request/games/update-game-icon.dto';

export class GamesApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get game locales
   * @returns LocaleResponse
   * @throws ApiError
   */
  public getLocales(): CancelablePromise<Array<LocaleResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/locales',
    });
  }
  /**
   * Get providers with manual game creation
   * @returns ManualProvidersResponse
   * @throws ApiError
   */
  public getProvidersWithManualGameCreation(): CancelablePromise<ManualProvidersResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/providers/manual',
    });
  }
  /**
   * Get games for vaix integration
   * @returns GetGamesVaixResponse
   * @throws ApiError
   */
  public getGamesForVaixIntegration(): CancelablePromise<GetGamesVaixResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/vaix',
    });
  }
  /**
   * Get game owners for selected providers
   * @returns SubproviderResponse
   * @throws ApiError
   */
  public getSubproviders({
    p,
  }: {
    p?: Array<PROVIDER>,
  }): CancelablePromise<Array<SubproviderResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/providers/game-owners',
      query: {
        'p': p,
      },
    });
  }
  /**
   * Get available providers
   * @returns AvailableProvidersResponse
   * @throws ApiError
   */
  public getAvailableProviders(): CancelablePromise<AvailableProvidersResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/providers/available',
    });
  }

  /**
   * Change image for game in locale
   * @returns UpdateGameImageResponse
   * @throws ApiError
   */
  public updateGameImage({
    gameId,
    localeId,
    formData,
    isCompressionEnabled,
    orientation,
  }: UpdateGameImageDto): CancelablePromise<UpdateGameImageResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/games/image',
      query: {
        'gameId': gameId,
        'localeId': localeId,
        'isCompressionEnabled': isCompressionEnabled,
        'orientation': orientation,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  public updateGameIcon({
    gameId,
    localeId,
    formData,
  }: UpdateGameIconDto): CancelablePromise<UpdateGameImageResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/games/icon',
      query: {
        'gameId': gameId,
        'localeId': localeId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }
  /**
   * @returns GameEntity
   * @throws ApiError
   */
  public updateGame({
    id,
    requestBody,
  }: {
    /**
     * Game ID
     */
    id: string,
    requestBody: UpdateGameDto,
  }): CancelablePromise<GameEntity> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/games/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve a single game
   * @returns GameEntity Get one base response
   * @throws ApiError
   */
  public getOneGame({
    id,
    fields,
    join,
    cache,
  }: {
    id: string,
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<GameEntity> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/{id}',
      path: {
        'id': id,
      },
      query: {
        'fields': fields,
        'join': join,
        'cache': cache,
      },
    });
  }
  /**
   * Create game
   * @returns CreateGameResponse
   * @throws ApiError
   */
  public createGame({
    requestBody,
  }: {
    requestBody: CreateGameDto,
  }): CancelablePromise<CreateGameResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/games',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve multiple games
   * @returns any Get many base response
   * @throws ApiError
   */
  public getGames({
    fields,
    s,
    filter,
    or,
    sort,
    join,
    limit,
    offset,
    page,
    cache,
  }: {
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
     */
    s?: string,
    /**
     * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
     */
    filter?: Array<string>,
    /**
     * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
     */
    or?: Array<string>,
    /**
     * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
     */
    sort?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
     */
    limit?: number,
    /**
     * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
     */
    offset?: number,
    /**
     * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
     */
    page?: number,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<(GetManyGameEntityResponseDto | Array<GameEntity>)> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games',
      query: {
        'fields': fields,
        's': s,
        'filter': filter,
        'or': or,
        'sort': sort,
        'join': join,
        'limit': limit,
        'offset': offset,
        'page': page,
        'cache': cache,
      },
    });
  }

  public getAggregators(query: {
    aggregatorProvider?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): CancelablePromise<ListResponseDto<AggregatorProviderDto>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/aggregators-providers',
      query,
    });
  }

  public patchAggregators({
    providerId,
    subproviderId,
    displayName,
    imageUrl,
    imageBigUrl,
  }: {
    providerId: string;
    subproviderId: string;
    displayName?: string | null;
    imageUrl?: Blob | File | null;
    imageBigUrl?: Blob | File | null;
  }): CancelablePromise<ProviderSettingsDto> {
    const formData: {
      providerId: string;
      subproviderId: string;
      displayName?: string | null;
      imageUrl?: Blob | File | string;
      imageBigUrl?: Blob | File | string;
    } = { providerId, subproviderId };

    if (displayName !== undefined) {
      formData.displayName = displayName === null ? 'null' : displayName;
    }

    if (imageUrl !== undefined) {
      formData.imageUrl = imageUrl === null ? 'null' : imageUrl;
    }

    if (imageBigUrl !== undefined) {
      formData.imageBigUrl = imageBigUrl === null ? 'null' : imageBigUrl;
    }

    return this.httpRequest.request({
      method: 'PATCH',
      url: '/games/aggregators-providers',
      formData,
      mediaType: 'multipart/form-data',
    });
  }

  public getGamesPositions(query: {
    aggregator: string;
    provider: string;
    localeId: number;
  }): CancelablePromise<GamePositionDto[]> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games/positions',
      query,
    });
  }

  public setGamesPositions(body: {
    aggregator: string;
    provider: string;
    gameId: string;
    localeId: number;
    position: number | string | null;
  }): CancelablePromise<GamePositionDto> {
    if (body.position === null) {
      body.position = 'null';
    }

    return this.httpRequest.request({
      method: 'PATCH',
      url: '/games/positions',
      body,
      mediaType: 'application/json',
    });
  }

  public deleteGame(id: string): CancelablePromise<GameEntity> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/games/{id}',
      path: { id },
      mediaType: 'application/json',
    });
  }

  public restoreGame(id: string): CancelablePromise<GameEntity> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/games/restore/{id}',
      path: { id },
      mediaType: 'application/json',
    });
  }
}
